import React from "react";
import ProductDetailModal from "src/core/products/components/v2/product-detail/ProductDetailModal";
import DefaultProductDetail from "src/core/products/components/v2/product-detail/ProductDetail";
import useRouter from "src/core/common/hooks/useRouter";
import {isClient} from "src/server/utils/isClient";

function ProductDetail({onRequestClose}) {
  const router = useRouter();
  const {productId, noBrandProductId} = router.query;
  const resolvedProductId = productId || noBrandProductId;

  return (
    <>
      {!isClient && resolvedProductId && (
        <DefaultProductDetail productId={resolvedProductId} />
      )}
      <ProductDetailModal
        isOpen={Boolean(resolvedProductId)}
        onRequestClose={onRequestClose}
      >
        {resolvedProductId && (
          <DefaultProductDetail key={resolvedProductId} productId={resolvedProductId} />
        )}
      </ProductDetailModal>
    </>
  );
}

export default ProductDetail;
